<template>
  <div v-show="isShowModal">
    <div class="spx-modal h-100 justify-content-center" 
   
    >
      <div class="spx-modal-body mx-auto"  :style="isShowBigWidth ? 'max-width: 1500px !important;width: 1105px;' : ''">
        <slot></slot>
      </div>
    </div>
    <div class="spx-modal-background"></div>
  </div>
</template>
<script>
export default {
  name: "DeleteModal",
  data() {
    return {
      isShowModal: false,
      isShowBigWidth: false,
    };
  },
  mounted() {},
  methods: {
    showModal() {
      this.isShowModal = true;
    },
    increaseModelWidth() {
      this.isShowBigWidth = true;
    },
    closeModal() {
      this.isShowModal = false;
    },
  },
};
</script>